import { IRaffleDefaultTicketTransactionStatusBadgeDTO } from "@hooks/dtos/raffles/IRaffleDefaultTicketTransactionDTO";
import {
  RaffleDefaultTicketTransactionStatusTypes,
  RaffleDefaultTicketTransactionStatusTypesEnum,
} from "@hooks/enums/raffle_default_ticket_transactions";

export const raffleDefaultTicketTransactionSelect: IRaffleDefaultTicketTransactionStatusBadgeDTO[] = [
  {
    status: RaffleDefaultTicketTransactionStatusTypesEnum.PAID,
    text: "Pago",
    title: "Esta aquisição foi paga.",
    color: "success",
  },
  {
    status: RaffleDefaultTicketTransactionStatusTypesEnum.WAITING,
    text: "Aguardando",
    title: "Esta aquisição está aguardando pagamento.",
    color: "info",
  },
  {
    status: RaffleDefaultTicketTransactionStatusTypesEnum.FAILED,
    text: "Falhou",
    title: "Esta aquisição falhou.",
    color: "danger",
  },
  {
    status: RaffleDefaultTicketTransactionStatusTypesEnum.DELETED,
    text: "Deletou",
    title: "Esta aquisição foi excluída.",
    color: "warning",
  },
  {
    status: RaffleDefaultTicketTransactionStatusTypesEnum.EXPIRED,
    text: "Expirou",
    title: "Esta aquisição expirou.",
    color: "danger",
  },
];

export const getRaffleDefaultTicketTransactionStatus = (
  status: RaffleDefaultTicketTransactionStatusTypes,
): IRaffleDefaultTicketTransactionStatusBadgeDTO => {
  let ret = raffleDefaultTicketTransactionSelect.find(
    (eventStatusType) => eventStatusType.status === status,
  );
  if (!ret)
    ret = { status: "x", text: "Error", title: "Error", color: "danger" };
  return ret;
};
